import moment from "moment";
export const getDateForChart = () => {

    let dateFormat = "YYYY-MM-DD";
    let timeFormat = 'HH:mm:ss';

    let date = moment(new Date(), dateFormat);

    let time = moment(new Date(), timeFormat);
    var beginningTime = moment('07:00:00', timeFormat);

    if (time.isBefore(beginningTime)) {
        // date = date -1;
        date = moment().subtract(1, "days");
    }

    return moment(date, dateFormat).toDate();
}